module.exports = __webpack_public_path__ + "static/3-09f744b26000908da57c2e451a0b03af.jpg";